import { render } from "./PayslipsPage.vue?vue&type=template&id=526e7ff8&scoped=true"
import script from "./PayslipsPage.vue?vue&type=script&lang=js"
export * from "./PayslipsPage.vue?vue&type=script&lang=js"

import "./PayslipsPage.vue?vue&type=style&index=0&id=526e7ff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526e7ff8"]])

export default __exports__